import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';

export interface AllGroupsSpaceProviderProps extends ReactDirectiveProps {}
const template = `<div ng-controller="GroupsPlaceCtrl" ng-include="'groupsPlace.html'"></div>`;
const groupsSpaceInfo: SpaceInfo = { spaceType: 'groups', subspaceName: undefined, item: SpaceItemForNonEntitySpace };

export class AllGroupsSpaceProvider extends React.Component<AllGroupsSpaceProviderProps> {
  private childScope: ng.IScope = null;

  public render() {
    return (
      <ConnectedSpaceInfoProvider spaceInfo={groupsSpaceInfo}>
        <div>
          <AngularDirective
            template={template}
            angularContext={this.props.angularContext}
            setupScope={this.setupScope}
          />
        </div>
      </ConnectedSpaceInfoProvider>
    );
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new();
    this.childScope = childScope;
    return childScope;
  }

  public componentWillUnmount() {
    // Angular doesn't trigger new scope creation when navigating to the same angular-ui-state
    // And we need the scope to be destroyed (Sorter.detach) in order for everyone to play nice
    // So we keep a reference to the child so we can destroy it.
    if (this.childScope) {
      this.childScope.$destroy();
    }
  }
}
